<template>
  <div class="RLayoutBox">
    <el-row :gutter="40">
      <el-col :span="7" class="PerTreeHeight">
        <el-button
          size="medium"
          style="display: block; margin: 0 auto; width: 76%"
          type="primary"
          icon="el-icon-plus"
          @click="addScrap"
          >添加物料分类</el-button
        >
        <div class="PerLine"></div>
        <el-tree
          :data="ScrapData"
          :props="treeProps"
          node-key="ScrapId"
          default-expand-all
          draggable
          :expand-on-click-node="false"
          @node-click="editScrap"
          @node-drop="handleDrop"
        >
          <span slot-scope="{ data }">
            <span>{{ data.ScrapName }}</span>
          </span>
        </el-tree>
      </el-col>
      <!-- 右侧表单 -->
      <el-col :span="17" style="padding: 0 16%">
        <div class="FromTitle">
          <div class="FromTitleBorder"></div>
          <div class="FromTitleText">物料管理</div>
        </div>
        <el-form
          ref="form"
          @submit.native.prevent
          :model="form"
          :rules="rules"
          status-icon
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="物料分类" prop="ParentType">
            <el-select v-model="form.ParentType" clearable @change="Addrules">
              <el-option value="1" label="总分类"></el-option>
              <el-option value="2" label="明细分类"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总分类" prop="ParentId" v-if="isshow">
            <RemoteSelect
              v-model="form.ParentId"
              url="VehicleScrap/GetParentScrap"
              code="ScrapId"
              name="ScrapName"
            >
            </RemoteSelect>
          </el-form-item>
          <el-form-item label="物料名称" prop="ScrapName">
            <el-input
              v-model="form.ScrapName"
              placeholder="物料名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="Unit" v-if="isshow">
            <RemoteSelect
              v-model="form.Unit"
              url="DataDic/GetItemsByType?dicType=CommonUnit"
              code="DicName"
              name="DicName"
            >
            </RemoteSelect>
          </el-form-item>
          <!-- <el-cascader :options="ScrapData">
  <template slot-scope="{ node, data }">
    <span>{{ data.ScrapName }}</span>
    <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
  </template>
</el-cascader> -->

          <el-form-item>
            <el-button type="primary" @click="save">保存</el-button>
            <el-button type="danger" @click="DeleteScrap" v-if="isEdit"
              >删除</el-button
            ><el-button type="canale" @click="resetFields">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      treeProps: {
        label: "ScrapName",
      },
      ScrapList: [],
      form: {},
      isshow: true,
      rules: {
        ParentType: [
          {
            required: true,
            message: "请选择类型",
          },
        ],
        ParentId: [
          {
            required: true,
            message: "请选择总分类",
          },
        ],
        ScrapName: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validLen(50),
        ],
        Unit: [
          {
            required: true,
            message: "不可为空",
          },
          this.$g.validLen(5),
        ],
      },
    };
  },
  computed: {
    ScrapData() {
      return this.$g.listToTree(this.ScrapList, "ScrapId", "ParentId");
    },
    PowerParent() {
      //没有选择或选的菜单组，上级权限选项为空
      if (!this.form.PowerKind || this.form.PowerKind == "1") {
        return [];
      }
      //权限为菜单的，上级权限为菜单组；权限为功能的，上级权限为菜单
      let res = this.PowerList.filter().map((r) => {
        return {
          code: r.ScrapId,
          name: r.ScrapName,
        };
      });
      return res;
    },
    defaultShowNodes() {
      let top = this.ScrapList.find((r) => !r.ParentId);
      if (!top) {
        return [];
      } else {
        return [top.ScrapId];
      }
    },
    isEdit() {
      if (this.form.ScrapId) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("VehicleScrap/GetList").then((r) => {
        this.ScrapList = r.Result;
      });
    },
    //节点拖拽成功完成时触发
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType);
    },
    Addrules(rows) {
      //总分类
      if (rows == 1) {
        //删除单位必填项
        this.$refs.form.clearValidate(["ParentId", "Unit"]);
        // 这行必须
        this.rules = { ...this.rules, ParentId: [], Unit: [] };
        this.$set(this.form, "ParentId", "");
        this.$set(this.form, "Unit", "");
        this.isshow = false;
      } else {
        const Unit = { required: true, message: "不可为空" };
        const ParentId = { required: true, message: "请选择总分类" };
        this.rules = { ...this.rules, Unit: Unit, ParentId: ParentId };
        this.isshow = true;
      }
    },
    PowerKindChange() {
      this.$set(this.form, "PowerParent", "");
    },
    addScrap() {
      this.Addrules(2);
      this.resetFields();
      this.form = {};
    },
    editScrap(data) {
      this.Addrules(data.ParentType);
      this.resetFields();
      this.form = { ...data };
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let params = { ...this.form };
        this.loading = true;
        if (this.isEdit) {
          this.$put("VehicleScrap/Edit", params).then((r) => {
            this.$message.success("修改成功");
            this.resetFields();
            this.getData();
          });
        } else {
          this.$post("VehicleScrap/Add", params).then((r) => {
            this.$message.success("添加成功");
            this.resetFields();
            this.getData();
          });
        }
      });
    },
    DeleteScrap() {
      if (this.form.children) {
        this.$message.error("存在子节点，不能删除，请先删除此节点下的子节点");
        return;
      }

      this.$confirm(`将删除此物料信息, 是否继续?`, "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "el-button--canale",
        type: "warning",
      })
        .then(() => {
          this.$delete("VehicleScrap/Delete", {
            ScrapId: this.form.ScrapId,
          }).then((r) => {
            this.$message.success("删除成功");
            this.resetFields();
            this.getData();
          });
        })
        .catch(() => {});
    },
    resetFields() {
      if (this.$refs["form"]) {
        this.form = {};
        this.$refs["form"].resetFields();
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.RLayoutBox {
  height: calc(100vh - 114px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.el-tree {
  height: calc(100vh - 190px - 6px - 15px);
  overflow-y: auto;
  margin: 0 10px;
}
</style>